import ApiService from "src/util/api.service";
import { getLanguageHeaders } from "./commonLanguageHeader";
import { ServicesUrlEndpoints } from "./servicesEndpointConstant";

export interface CommandHistoryParams {
  unitId: string | number;
  page: number;
  size?: number;
}

export interface CommandHistoryRecord {
  id: number;
  command?: {
    id: number;
    internalName: string;
    commandForms: string[];
    commandTransport: string;
    expire: number;
  } | null;
  params?: Record<string, unknown> | null;
  updatedBy: string;
  createdDate: number;
  updatedDate: number;
  response?: string | null;
  status: 1 | 2 | 3 | 4;
  reason?: string | null;
}

export interface CommandHistoryResponse {
  totalItems: number;
  items: CommandHistoryRecord[];
  totalPages: number;
  currentPage: number;
}

export const getCommandHistory = (
  params: CommandHistoryParams,
  language?: string,
) =>
  ApiService.get<{ response: CommandHistoryResponse }>(
    `${ServicesUrlEndpoints.COMMAND_HISTORY.LIST}/${params.unitId}/history`,
    {
      params: {
        page: params.page,
        size: params.size,
      },
      ...getLanguageHeaders(language),
    },
  );
